<template>
  <li class="cell">
    <div class="cell-container" :class="{ open: open, fav: isFavorite, onFavoritesPage: onFavoritesPage, willTrigger: dragExceededThreshold }">
      <div class="cell-content" :class="{ animate: !dragging, dragging: dragging }" v-on:click="cellClick(artist.id)">
        <img v-if="artist.artwork.length && artist.artwork[0].images.length && artist.artwork[0].images[0].image" class="cell-img" :style="'background-image:url(' + encodeURI(artist.artwork[0].images[0].image.url) + ')'" :aria-label="artist.artwork[0].images[0].image.alt">
        <div v-else-if="artist.headshot" class="cell-img" :style="'background-image:url(' + encodeURI(artist.headshot.url) + ')'" :aria-label="artist.headshot.alt"></div>

        <div class="cell-fields">
          <span class="cell-title"><span class="artist-number"><template v-if="artist.tour_number">{{artist.tour_number}}. </template></span><span v-html="artist.name"></span></span>
          <p>{{ artist.type }} <span v-if="artist.tour_address">–</span> {{ artist.tour_address }}</p>
        </div>
      </div>

      <div class="cell-action" @click="actionClick" :class="{ animate: !dragging || dragDiff < -90 || hasExceededThreshold }"></div>
    </div>
  </li>
</template>

<script>
export default {
  props: ['artist', 'onFavoritesPage'],
  data() {
    return {
      cellContent: null,
      cellAction: null,
      open: false,
      didDrag: false,
      dragging: false,
      dragStartPos: 0,
      dragDiff: 0,
      lastDragDiff: 0,
      dragThreshold: -window.innerWidth / 2,
      dragExceededThreshold: false,
      hasExceededThreshold: false,
    };
  },
  computed: {
    isFavorite() {
      return this.$parent.favorites.includes(this.artist.id);
    },
  },
  methods: {
    cellClick(id) {
      if (!this.dragging && !this.open && !this.didDrag) {
        this.$router.push('/participants/' + id);
      }
    },
    translateX(pos) {
      return 'translate(' + pos + 'px, 0)';
    },
    fav() {
      let artistID = this.artist.id;

      if (this.$parent.favorites.indexOf(artistID) > -1) {
        // Unfavorite
        if (this.onFavoritesPage) {
          this.$el.style.height = 0;
          setTimeout(() => {
            this.$parent.favorites.splice(this.$parent.favorites.indexOf(artistID), 1);
            localStorage.setItem('favorites', JSON.stringify(this.$parent.favorites));
          }, 750);
        } else {
          this.$parent.favorites.splice(this.$parent.favorites.indexOf(artistID), 1);
        }
      } else {
        // Favorite
        this.$parent.favorites.push(artistID);
        gtag('event', 'favorite', {
          'artist': this.artist.id.toString() + ' ' + this.artist.name
        });
      }

      localStorage.setItem('favorites', JSON.stringify(this.$parent.favorites));
    },
    actionEnd() {
      this.cellContent.style = null;
      this.cellAction.style = null;
    },
    actionClick() {
      this.actionEnd();
      this.closeAction(true);
    },
    openAction() {
      this.open = true;
      this.lastDragDiff = -90;
    },
    closeAction(fav) {
      this.open = false;
      this.lastDragDiff = 0;
      if (fav) this.fav();
    }
  },
  mounted() {
    this.cellContent = this.$el.querySelector('.cell-content');
    this.cellAction = this.$el.querySelector('.cell-action');

    let cellStart = e => {
      this.dragStartPos = e.touches[0].clientX;
    };
    let cellMove = e => {
      this.dragging = true;
      this.dragDiff =
        e.touches[0].clientX - this.dragStartPos + this.lastDragDiff;

      if (this.dragDiff < -10) {
        document.querySelector('body').classList.add('stop-scroll');
        this.didDrag = true;
      }

      if (this.dragDiff > 0) {
        this.cellContent.style.transform = this.translateX(0);
        this.cellAction.style.transform = this.translateX(-90 + 'px');
        return;
      }

      if (this.dragDiff <= this.dragThreshold) {
        // Drag met or exceeded dragThreshold
        if ('ReactNativeWebView' in window && !this.dragExceededThreshold) {
          window.ReactNativeWebView.postMessage('impactMedium');
        }
        this.cellContent.style.transform = this.translateX(this.dragThreshold);
        this.cellAction.style.transform = this.translateX(this.dragThreshold + 90);
        this.dragExceededThreshold = true;
        this.hasExceededThreshold = true;
      } else {
        // Drag below dragThreshold
        this.cellContent.style.transform = this.translateX(this.dragDiff);

        // If dragExceededThreshold is still true, move cellAction back to start
        if (this.dragExceededThreshold) {
          if ('ReactNativeWebView' in window && this.dragExceededThreshold) {
          window.ReactNativeWebView.postMessage('impactLight');
        }

          this.cellAction.style.transform = this.translateX(0);
          this.dragExceededThreshold = false;
          setTimeout(() => {
            this.hasExceededThreshold = false;
          }, 800);
        }

        if (this.dragDiff >= -90) {
          // Move cellAction while above -90
          this.cellAction.style.transform = this.translateX(90 - Math.abs(this.dragDiff));
        } else {
          // Keep cellAction open while below -90
          this.cellAction.style.transform = this.translateX(0);
        }
      }
    };
    let cellEnd = e => {
      document.querySelector('body').classList.remove('stop-scroll');
      this.dragging = false;

      if (this.dragDiff > -25 && this.dragDiff < 0) {
        // Keep actions closed
        this.actionEnd();
        this.closeAction();
      } else if (this.dragDiff <= -25 && this.dragDiff >= this.dragThreshold) {
        // Open actions
        this.actionEnd();
        this.openAction();
      } else if (this.dragDiff <= this.dragThreshold) {
        // Trigger action
        this.closeAction(true);

        if (this.onFavoritesPage) {
          this.open = true;
          return;
        }
        this.actionEnd();
      }

      this.dragDiff = 0;
      this.didDrag = false;
      this.dragExceededThreshold = false;
      this.hasExceededThreshold = false;
    };

    let xDown = null;
    let yDown = null;
    let draggedX = false;

    this.$el.addEventListener('touchstart', e => {
      xDown = e.touches[0].clientX;
      yDown = e.touches[0].clientY;
      cellStart(e);
    });
    this.$el.addEventListener('touchmove', e => {
      if (draggedX) cellMove(e);

      // Check if drag direction was along x
      // Prevents cellMove firing when scrolling page
      if (!xDown || !yDown) return;
      let xUp = e.touches[0].clientX;
      let yUp = e.touches[0].clientY;
      let xDiff = xDown - xUp;
      let yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        draggedX = true;
      }

      xDown = null;
      yDown = null;
    });
    this.$el.addEventListener('touchend', e => {
      draggedX = false;
      cellEnd(e);
    });
    window.addEventListener('resize', () => {
      this.dragThreshold = -window.innerWidth / 2;
    });

    if (this.onFavoritesPage) {
      setTimeout(() => {
        this.$el.style.height = this.$el.clientHeight + 'px';
      }, 500);
    }
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.cell {
  position: relative;
  transition: height 0.4s;
  overflow: hidden;
  padding-left: 20px;
}

.cell-container {
  background: linear-gradient(150deg, @themeColor1 60%, @themeColor3);
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity .4s;
    background: linear-gradient(150deg, #5d5d5d, #000000);
  }
  &.open {
    .cell-content {
      transform: translateX(-90px);
    }
    .cell-action {
      transform: translateX(0);
    }
  }
  &.fav {
    &.willTrigger {
      &::before {
        opacity: 1;
      }
      .cell-action {
        background-image: url(../assets/img/icon-x.svg);
      }
    }
    .cell-content {
      margin-right: 7px;
    }
    .cell-action {
      background-image: url(../assets/img/icon-fav-active.svg);
    }
  }
}

.cell-action {
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 100%;
  transform: translateX(90px);
  background-image: url(../assets/img/icon-fav.svg);
  background-size: 28px 25px;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  &.animate {
    transition: transform 0.4s;
  }
}

.cell-content {
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 20px 20px 0;
  transform: translateX(0);
  color: #000;
  text-decoration: none;
  background-color: #fff;
  border-bottom: 1px solid #EBEBEB;
  z-index: 2;
  &.animate {
    transition: transform 0.4s, margin-right 0.4s;
  }
  &:not(.dragging) {
    &:active {
      background-color: #f5f5f5;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -20px;
        width: 20px;
        height: 100%;
        background: #f5f5f5;
      }
    }
  }
  .cell-img {
    min-width: 61px;
    height: 61px;
    background-size: cover;
    background-position: center;
    background-color: #1e1e1e;
    border-radius: 61px;
    margin-right: 13px;
  }
  .cell-fields {
    max-width: calc(~'100% - 74px');
    .cell-title {
      display: block;
      overflow: hidden;
      font-size: 25px;
      font-weight: bold;
      line-height: 33px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p {
      overflow: hidden;
      font-size: 15px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cell.vue